// The point of this plugin is to be constantly watching the municipality cookie and change the Nuxt UI css when needed.
export default defineNuxtPlugin({
  name: 'municipality',
  enforce: 'pre', // Run before other plugins
  setup(nuxtApp) {
    const municipality = useCookie('municipality');
    const useMunicipalityBranding = useCookie('useMunicipalityBranding');
    const user = useState('user');

    // Function to determine municipality class
    const getMunicipalityClass = () => {
      if (!municipality.value) return null;
      if (user.value?.subscription === 'builder') return null;
      if (!useMunicipalityBranding.value) return null;
      return municipality.value;
    };

    // Server-side rendering
    if (process.server) {
      const initialClass = getMunicipalityClass();
      if (initialClass) {
        useHead({
          htmlAttrs: {
            class: initialClass
          }
        });
      }
    }

    // Client-side updates
    if (process.client) {
      // Function to update classes
      const updateClasses = () => {
        const newClass = getMunicipalityClass();

        // Remove any existing municipality classes
        if (municipality.value) {
          document.documentElement.classList.remove(municipality.value);
        }

        // Add new class if we have one
        if (newClass) {
          document.documentElement.classList.add(newClass);
        }
      };

      // Update classes when the app is mounted
      nuxtApp.hook('app:mounted', () => {
        updateClasses();
      });

      // Watch for changes
      watch([municipality, useMunicipalityBranding, () => user.value?.subscription], () => {
        updateClasses();
      }, { deep: true });
    }
  }
});